import { useQueryClient } from '@tanstack/react-query';
import { GET_ALL_CHALLENGES_KEY } from '_api/queries/challenge/useGetAllChallenges';
import { GET_MY_LIBRARY_CHALLENGES_KEY } from '_api/queries/challenge/useGetMyLibraryChallenges';

import useApiMutation from '../useApiMutation';

export const DELETE_CHALLENGE_BY_ID_KEY = 'delete-challenge-by-id';

export const useDeleteChallengeById = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, { id: number }>(
    ({ id }) => `/challenge/${id}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_CHALLENGE_BY_ID_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_CHALLENGES_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_MY_LIBRARY_CHALLENGES_KEY] });
      },
    },
  );
};
